const feVersion = {
    ciBuildNumberTemplate: '20261105.14',
    ciBranchNameTemplate: 'dev',
    ciCommitIdTemplate: 'aa4b373ace71fbf2f597dfd6d90596d2188f3ad3',
    buildNumber: 440,
    version: '3.8.1',
    databaseVersion: 30801,
    shortCommitId: function () {
        if (this.ciCommitIdTemplate.length > 7 && !this.ciCommitIdTemplate.startsWith('#')) {
            return this.ciCommitIdTemplate.substring(0, 7);
        }
        return this.ciCommitIdTemplate;
    }
};

export default feVersion;
